module.exports = __webpack_public_path__ + "static/img/20260921001.26a54fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20260921001.jpg
// module id = 52aT
// module chunks = 0